import type {
  TMentionFacets,
  TRange,
} from '@/features/mentions/components/MentionFilters/active-options/active-options';
import { mediaManagerClient } from '@/lib/axios';

export async function getSegmentMentionFacets({ gte, lte }: TRange): Promise<TMentionFacets> {
  return mediaManagerClient.get('/api/v1/segment_mention_facets', {
    params: {
      start_datetime__gte: gte || undefined,
      end_datetime__lte: lte || undefined,
    },
  });
}
